import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";

const initialState = {
  ...defaultState("customers", { metadata: undefined }, []),
  ...defaultState("customer", { metadata: undefined }, {}),
};

const customerCreatedSuccess = (state, draft, payload) => {
  const customers = state.customers || [];
  draft.customers = [...customers, payload];
  draft.openDialog = false;
};

const customerEditedSuccess = (state, draft, payload) => {
  const customers = state.customers || [];
  const index = customers.findIndex((u) => u.id === payload.id);
  if (index >= 0) {
    draft.customers[index] = payload;
  }
  draft.openDialog = false;
};

const customerDeleteSuccess = (state, draft, payload) => {
  const customers = state.customers || [];
  const deletedId = payload && (payload.id || payload);
  if (deletedId) {
    draft.customers = customers.filter((a) => a.id != deletedId);
  }
  draft.openDeleteDialog = false;
};

const showDeleteDialog = (state, draft, payload) => {
  draft.openDeleteDialog = true;
};

const resetDialog = (state, draft, payload) => {
  draft.openDialog = false;
  draft.openDeleteDialog = false;
  draft.customer_errors = [];
};

export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {
    action: "getAllCustomers",
    stateName: "customers",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "getCustomerWithId",
    stateName: "customer",
    async: true,
    isPaginated: false,
  }),
  ...bindReducers(ActionTypes, {
    action: "addCustomer",
    stateName: "customer",
    async: true,
    isPaginated: false,
    successCb: customerCreatedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editCustomer",
    stateName: "customer",
    async: true,
    isPaginated: false,
    successCb: customerEditedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "deleteCustomer",
    stateName: "customer",
    async: true,
    isPaginated: false,
    successCb: customerDeleteSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "showDeleteDialog",
    stateName: "showDeleteDialog",
    async: false,
    isPaginated: false,
    successCb: showDeleteDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "resetDialog",
    stateName: "resetDialog",
    async: false,
    isPaginated: false,
    successCb: resetDialog,
  }),
});
